import {
  updateData,
  updateSupportData,
  updateValidation,
} from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY, CHILDREN_CRUD_OVERVIEW } from '../PersonalInfoWorkflowConstants';
import { buildMutation } from '../../AdvWorkflow/AdvWorkflowHelpers';

export const onCancel = (workflowId, clientId, isEdit, children) => (dispatch) => {
  dispatch(updateValidation(buildMutation(`${BACKEND_KEY}.ChildrenAddEdit`, []), workflowId, clientId));

  if (!isEdit) {
    dispatch(updateData(
      {
        [BACKEND_KEY]: {
          Dependents: children.slice(0, children.length - 1),
        },
      },
      workflowId,
      clientId,
    ));
  }
  dispatch(updateSupportData(
    {
      [BACKEND_KEY]: {
        ChildrenStepViewID: CHILDREN_CRUD_OVERVIEW,
      },
    },
    workflowId,
    clientId,
  ));
};

export default onCancel;
